import { gql } from '@/shared/graphql/generated/explorer';

gql(/* GraphQL */ `
  fragment RecentPoolOrderEvent on RecentPoolOrderEvent {
    id
    eventType
    orderType
    baseAmount
    baseAsset
    quoteAmount
    maximumRate
    minimumRate
    timestamp
    lp: liquidityProviderByLiquidityProviderId {
      account: accountByAccountId {
        idSs58
      }
    }
    event: eventByEventId {
      indexInBlock
      blockId
    }
  }
`);

export const getPoolAggregatesByDateQuery = gql(/* GraphQL */ `
  query GetPoolAggregatesByDate($startingTimestamp: Datetime!, $endingTimestamp: Datetime) {
    poolSwaps: allPoolSwaps(
      filter: {
        assetSwappedBlockTimestamp: {
          greaterThanOrEqualTo: $startingTimestamp
          lessThanOrEqualTo: $endingTimestamp
        }
      }
    ) {
      groupedAggregates(groupBy: [FROM_ASSET, TO_ASSET]) {
        fromAssetToAsset: keys
        sum {
          toValueUsd
        }
      }
    }
  }
`);
